<template>
    <div class="dashboard__view">
        <div class="page">
            <div class="page__title">Admin User</div>
        </div>

        <div @click="$router.go(-1)" class="page__nav">
            <div class="page__nav__icon">
                <svg fill="none" height="16" viewBox="0 0 19 16" width="19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z" fill="#655D79" />
                </svg>
            </div>
            <div class="page__nav__text">Update user permissions</div>
        </div>
        <div class="page__content" v-if="merchantID !== ''">
            <div class="nuban">
                <div class="nuban__title">
                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
                        <path d="M30.7181 3.82796C16.39 3.42171 4.42123 14.7655 4.01497 29.0936C3.60873 43.4217 14.9525 55.4061 29.2806 55.8123C43.6087 56.203 55.5931 44.8748 55.9994 30.5311C56.0775 27.5311 55.6244 24.6405 54.7494 21.9373L51.4525 25.0467C51.8431 26.7811 52.0462 28.578 51.9994 30.4373C51.6556 42.5623 41.515 52.1405 29.39 51.8123C17.265 51.4686 7.67123 41.328 7.99935 29.203C8.3431 17.078 18.4837 7.48422 30.6087 7.81234C34.5775 7.93734 38.265 9.10922 41.4369 11.0623L44.4369 8.21859C40.4994 5.59359 35.8118 3.96859 30.7181 3.82796ZM49.9994 11.1717L25.9993 35.1717L19.4056 28.5936L17.9994 27.1717L15.1712 29.9998L16.5931 31.4061L25.9993 40.828L52.8275 13.9998L49.9994 11.1717Z" fill="#e00b5b" />
                    </svg>
                </div>
                <div class="nuban__title">Admin Permissions Updated</div>
                <div class="nuban__caption">admin permissions updated successfully</div>
                <div class="nuban__action">
                    <router-link class="btn btn--primary" to="/dashboard/users?page=1">Back to Admin</router-link>
                </div>
            </div>
        </div>
        <div class="page__content" v-else>
            <div class="profile nobar">
                <div class="profile__left">
                    <div class="profile__title">Admin User Permissions</div>
                    <div class="profile__caption">Modify admin permissions</div>
                </div>
                <div class="profile__right">
                    <div class="form__flex">
                        <div class="form__flex__item">
                            <label class="form__label" for>Full Name</label>
                            <input class="form__input" type="text" disabled :value="userInfo.fullname"/>
                        </div>
                        <div class="form__flex__item">
                            <label class="form__label" for>Phone Number</label>
                            <input class="form__input num__input" maxlength="11" type="number" :value="userInfo.mobile_number" disabled/>
                        </div>
                    </div>
                    <div class="form__flex">
                        <div class="form__flex__item">
                            <label class="form__label" for>Email</label>
                            <input autocomplete="off" class="form__input" type="email" :value="userInfo.email" disabled/>
                        </div>
                        <div class="form__flex__item" style="visibility: hidden;">
                            <label class="form__label" for>Password</label>
                            <input autocomplete="new-password" class="form__input" type="password" />
                        </div>
                    </div>
                    <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
                        <span> Select admin permissions</span>
                        <span style="display: flex; align-items: center; gap: 4px;">
                            <input type="checkbox" @change="toggleSelectAllPermissions" :checked="selectedPermissions.length === permissions.length">
                            <span style="font-size: 14px; line-height: 20px; margin-top: 4px;">
                                Select all
                            </span>
                        </span>
                    </div>
                    <div class="" style="display: flex; flex-wrap: wrap; width: 100%; gap: 8px; margin-bottom: 28px;">
                        <div class="" style="display: flex; justify-content: space-between; align-items: center; border: 1px solid #cbd2d9; width: fit-content; padding: 4px; border-radius: 4px; gap: 6px;" v-for="permission in permissions" :key="permission.id">
                            <input type="checkbox"
                                @input="addPermission(permission.id)"
                                :checked="selectedPermissions.includes(permission.id)"
                            />
                            <span style="margin-top: 4px;">
                                {{ permission.permission_name.replace(/_/g, " ") }}
                            </span>
                        </div>
                    </div>
                    <AuthPin :containerClass="'pin-input-container-left'" :titleClass="'pin-title-sm'" :inputContainerClass="'pin-inputs-left'" @complete="handlePinComplete"/>
                </div>
            </div>
            <div class="action">
                <button :disabled="disabled" @click="updeateUserPermissions" class="btn btn--primary">Update</button>
            </div>
        </div>
    </div>
</template>

<script>
  import AuthPin from '@/components/authPin.vue';
import { userInfo } from 'os';
export default {
    metaInfo: {
        title: "Create Admin User"
    },
    data() {
        return {
            merchantID: "",
            selectedPermissions: [],
            permissions: [],
            userInfo: {},
            otp_code: "",
            loading: false
        };
    },
    components: {
      AuthPin
    },
    created() {},
    computed: {
        disabled() {
            return !this.otp_code || this.otp_code.length < 6 || this.loading;
        }
    },
    methods: {
        handlePinComplete(pin) {
            this.otp_code = pin;
        },
        addPermission(permission) {
            if (this.selectedPermissions.includes(permission)) {
                this.selectedPermissions = this.selectedPermissions.filter(
                    (perm) => perm !== permission
                );
            } else {
                this.selectedPermissions.push(permission);
            }
        },
        updeateUserPermissions(value) {
            if (this.selectedPermissions.length > 0) {
                this.loading = true;
                let requestObject = {
                    permission_ids: this.selectedPermissions,
                    totp_code: this.otp_code
                };
                this.$http
                    .put(`admin/users/${this.$route.params.id}/permissions`, requestObject)
                    .then(response => {
                        this.loading = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "success text-white",
                            title: "Success",
                            text: response.body.message
                        });
                        this.merchantID = "Merchant";
                    })
                    .catch(error => {
                        this.loading = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: error.body.message
                        });
                    });
            } else {
                this.$notify({
                    group: "notifications-default",
                    type: "error text-white",
                    title: "Error",
                    text: "Select at least one permission"
                });
            }
        },
        async getPermissions() {
            const response = await this.$http.get(`admin/permissions`);
            let data = response.body.data;
            this.permissions = data;
        },
        async getUserPermissions() {
            const response = await this.$http.get(`admin/users/${this.$route.params.id}/permissions`);
            let data = response.body.data;
            this.selectedPermissions = data.permissions.map(perm => perm.permission_id);
        },
        toggleSelectAllPermissions() {
            if (this.selectedPermissions.length === this.permissions.length) {
                this.selectedPermissions = [];
            } else {
                this.selectedPermissions = this.permissions.map(perm => perm.id);
            }
        }
    },
    mounted() {
        this.getPermissions();
        this.getUserPermissions();
        if (!this.$route.query.admin) this.$router.go(-1);
        this.userInfo = this.$route.query.admin;
    }
};
</script>
<style lang="scss" scoped>
.num__input::-webkit-inner-spin-button,
.num__input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.nuban {
    padding: 100px 25px 120px;
    text-align: center;
    &__number {
        color: #e8368f;
        font-size: 32px;
        line-height: 35px;
        padding: 19px 28px 15px;
        background-color: rgba(#e8368f, 0.15);
        border-radius: 16px;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 32px;
        position: relative;
    }

    &__title {
        color: #261940;
        font-size: 18px;
        line-height: 20px;
        margin-bottom: 16px;
    }

    &__caption {
        color: rgba(#261940, 0.8);
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 32px;
    }

    &__copy {
        position: absolute;
        color: #e00b5b;
        font-size: 12px;
        line-height: 13px;
        top: -20px;
        right: 0;
        cursor: pointer;
    }
}
</style>